// @flow
import React, { Component } from 'react'
import Axios from 'axios'
import { StyledRow, StyledContent } from './style'
import { Card, Form, Input, Button, Col, Row, Alert } from 'antd'

const FormItem = Form.Item

type Props = {
  form: Form
}

type State = {
  form: {
    firstName: string,
    lastName: string,
    email: string,
    description: string,
    reason: string
  },
  error: string,
  success: string
}

const initialState: State = {
  form: {
    firstName: '',
    lastName: '',
    email: '',
    description: '',
    reason: ''
  },
  error: '',
  success: ''
}

class TicketsContainer extends Component<Props, State> {

  state: State = {
    form: {
      firstName: initialState.form.firstName,
      lastName: initialState.form.lastName,
      email: initialState.form.email,
      description: initialState.form.description,
      reason: initialState.form.reason
    },
    error: initialState.error,
    success: initialState.success,
  }

  handleSubmit = (e: Object) => {

    e.preventDefault()

    this.props.form.validateFields((err, values) => {
      if (!err) {
        const form: Form = {...this.state.form, ...values}
        this.submitTicket(form)
      }
    })
  }

  submitTicket = async (form) => {

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Basic MTFRTE9QSTVKSEN3OVU4UzJBdTpY',
    }

    const data = {
      name: `${form.firstName} ${form.lastName}`,
      email: form.email,
      description: form.description,
      subject: form.reason,
      status: 2,
      priority: 4,
    }

    const resp = await Axios.post('https://optionsedullc.freshdesk.com/api/v2/tickets', data, { headers })
    
    if (resp.status === 201) {

      this.setState({
        success: "Ticket created successfully",
        error: "",
      })
      this.handleReset()
    } else {
      this.setState({
        error: "Something went wrong",
        success: "",
      })
    }
  }

  handleReset = () => {

    // reset to initial state
    this.setState({form: initialState.form, error: '' })
    this.props.form.resetFields()
  }

  onAlertClose = () => {
      this.setState({ success: '', error: '' })
  }

  render() {

    // --- Props and State ---
    const { getFieldDecorator } = this.props.form
    const { form, error, success } = this.state
    const message = success || error

    return (
      <StyledContent>
        <Card title="Add Ticket">
          <Row gutter={16}>
            {
              error || success ?
              <Col sm={24} xs={24}>
                <Alert closable onClose={this.onAlertClose} message={message} type={success ? 'success' : error ? 'error' : ''} showIcon/>
              </Col>
              : null
            }
            <Col span={24}>
              <Form onSubmit={this.handleSubmit}>
                <Row gutter={16}>
                  <Col sm={24} xs={24}>
                    <FormItem label="Subject">
                      {getFieldDecorator('reason', {
                        initialValue: form.reason,
                        rules: [
                          {
                            required: true, message: 'Please input subject!',
                          }
                        ]
                      })(<Input/>)}
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col sm={12} xs={24}>
                    <FormItem label="First Name">
                      {getFieldDecorator('firstName', {
                        initialValue: form.firstName,
                        rules: []
                      })(<Input/>)}
                    </FormItem>
                  </Col>
                  <Col sm={12} xs={24}>
                    <FormItem label="Last Name">
                      {getFieldDecorator('lastName', {
                        initialValue: form.lastName,
                        rules: []
                      })(<Input/>)}
                    </FormItem>
                  </Col>
                  
                </Row>
                <Row>
                  <Col sm={24} xs={24}>
                    <FormItem label="Email">
                      {getFieldDecorator('email', {
                        initialValue: form.email,
                        rules: [{
                          type: 'email', message: 'The input is not valid E-mail!',
                        }, {
                          required: true, message: 'Please input your E-mail!',
                        }]
                      })(<Input/>)}
                    </FormItem>
                  </Col>
                </Row>
                <FormItem label="Description">
                  {getFieldDecorator('description', {
                    initialValue: form.description,
                    rules: []
                  })(<Input.TextArea/>)}
                </FormItem>
                <StyledRow gutter={8}>
                  <Col>
                    <FormItem>
                      <Button onClick={this.handleReset}>
                        Reset
                      </Button>
                      <Button type="primary" htmlType="submit">
                        Submit
                      </Button>
                    </FormItem>
                  </Col>
                </StyledRow>
              </Form>
            </Col>
          </Row>
        </Card>
      </StyledContent>
    )
  }
}

const TicketsContainerForm = Form.create()(TicketsContainer)
export default TicketsContainerForm



// WEBPACK FOOTER //
// ./src/components/customer-support/index.js